import React, { Component, useRef } from 'react';
import PropTypes from 'prop-types';
import './table-row.scss';
import { GECKO_UTILS } from '../../../';
import GeckoTableCell from '../table-cell/table-cell.jsx';
import {
  GeckoTableCellsModel,
  GeckoTableMassActionModel,
} from '../../../models';

const MassActionCell = ({ massAction, row, index }) => {
  const checkboxRef = useRef(null);
  const isChecked = massAction.isRowSelected(row, index);
  const preventRowHandlerClick = (event) => event.stopPropagation();
  const onChange = () => {
    return massAction.onRowSelected(row, index);
  };
  const onCellClick = (event) => {
    preventRowHandlerClick(event);
    checkboxRef.current.focus();
    checkboxRef.current.click();
  };
  return (
    <td onClick={onCellClick} aria-label={`Select row ${index + 1}`}>
      <input
        type="checkbox"
        checked={isChecked}
        onClick={preventRowHandlerClick}
        onChange={onChange}
        ref={checkboxRef}
      />
    </td>
  );
};

class GeckoTableRow extends Component {
  renderMassAction() {
    if (!this.props.massAction) {
      return null;
    }
    return (
      <MassActionCell
        massAction={this.props.massAction}
        row={this.props.row}
        index={this.props.index}
      />
    );
  }

  renderCells() {
    return this.props.cols.map((col, i) => (
      <GeckoTableCell
        col={col}
        row={this.props.row}
        index={this.props.index}
        colIndex={i}
        key={i}
      />
    ));
  }

  render() {
    const isChecked = this.props.massAction?.isRowSelected(
      this.props.row,
      this.props.index
    );
    return (
      <tr
        className={`${GECKO_UTILS.prepareNameClass(
          'gecko-table-row',
          this.props.index
        )} ${isChecked ? 'selected' : ''}`}
        onClick={this.props.rowHandler.bind(
          this,
          this.props.row,
          this.props.index
        )}
      >
        {this.renderMassAction()}
        {this.renderCells()}
      </tr>
    );
  }
}

GeckoTableRow.defaultProps = {
  cols: [],
  row: {},
  rowHandler: (row, i) => {},
};

GeckoTableRow.propTypes = {
  cols: GeckoTableCellsModel.isRequired,
  row: PropTypes.object.isRequired,
  massAction: GeckoTableMassActionModel,
};

export default GeckoTableRow;
